import { useEffect,useState } from "react";
import { Link } from 'react-router-dom';
import { APISERVERURL } from '../APIServerURL';
import { useNavigate } from "react-router-dom";

import studentapi from '../api/studentapi';
import loginapi from '../api/login';

function HomeStudent({accessToken,setAccessToken,setRefreshFailed,userFullName}) {
  const navigate = useNavigate();  
 const [isAppLoaded,setIsAppLoaded]=useState(true);

function downloadFile(fname)
  {
    fetch(`${APISERVERURL}/studentpdf/${fname}`).then((response) => {
      response.blob().then((blob) => {         
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = fname;
          alink.click();
          setIsAppLoaded(true);
      });
    });
  }

const getAdmitCardsOfAStudent=async ()=>{
  try{
    //alert(img+" "+postId);
    //post request to deletePhoto wit {id,fileName}
    setIsAppLoaded(false);
    const response= await studentapi.post('/getMyRegistrationCard',{},{headers:{'Authorization':`Bearer ${accessToken}`}});    
    alert(JSON.stringify(response.data));
    downloadFile(response.data);
  }
  catch(err)
  {
    if( err.response.status===403)
      {
        navigate(`/accessdenied`); 
      }
    try{
      const config = { withCredentials: true };
      const x=await loginapi.get('/getAccessToken',config);
      //alert(JSON.stringify(x['data']['accessToken']));
      
      const nat=x['data']['accessToken'];
      setAccessToken(nat);
      //console.log(`ne at ${nat}`);
      //console.log(`Second at:${accessToken}`);
      //alert('ok');
      try{       
        const response= await studentapi.post('/getMyRegistrationCard',{},{headers:{'Authorization':`Bearer ${nat}`}});    
         alert(JSON.stringify(response.data));
        downloadFile(response.data);
       }
       catch(err)
       {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        alert('unusual error newposts.js');
        setIsAppLoaded(true);
        //alert(JSON.stringify(err));
        //navigate('/');
       }
    }
    catch(err)
    {
      alert(JSON.stringify(err));
      setIsAppLoaded(true);
      //setError(JSON.stringify(err));
      //navigate('/');
    }

  }
}

  return (
    <main>
      <article className='newPost'>
      <div className="fullWidth">
        <p className="w-full text-center">Welcome,</p>
      <p className="text text-info baseddDiv text-2xl">{userFullName}</p>
          <div className="fullWidth featureContainer ">
                <button className="featureButton" onClick={getAdmitCardsOfAStudent}>DOWNLOAD REGISTRATION CARD</button> 
          </div>
      </div>
      </article>
    </main>
    )
  }
  
  export default HomeStudent